<template lang="html">
  <div class="search-container">
    <input type="text" class="search-bar" :placeholder="placeholder" :value="value" name="search" autocomplete="off" @input="handleInput">
    <button type="submit"><img class="search-icon" src="@/assets/magnifying-glass.png"></button>
  </div>
</template>

<script>
export default {
  props: ['value',"placeholder"],
  name: 'SearchField',
  methods: {
    handleInput(event) {
      this.$emit('change', event.target.value);
    }
  }
}
</script>

<style lang="scss" scoped>
.search-container{
  width:300px;
  position: relative;
  max-width: 321px;
}
.search-bar {
    width: 100%;
    border: 1px solid #d6d4d4;
    border-radius: 3px;
    height: 35px;
    padding: 5px;
    outline: none;
    position: relative;
}
.search-icon {
    position: absolute;
    right: 10px;
    top: 6px;
    width: 18px;
    height: 18px;
    left:inherit;
}

</style>
